export const environment = {
  assetsUrl: 'https://tu360.bancolombia.com/mega-menu/assets',
  urlPortal: 'www.bancolombia.com/personas',
  urlTu360: 'www.bancolombia.com/tu360',
  contenful: ''
};